/** The `{ error: { message } }` text of an offer-service refusal, if the error carries one. */
export const apiMessage = (error: unknown): string | undefined =>
	(error as { response?: { data?: { error?: { message?: unknown } } } })?.response?.data?.error?.message as
		| string
		| undefined
